// import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { EntradaService } from '../../_services';
import { InventarioService } from '../../_services';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FulfillmentService } from '../../_services';
import { TranslateService } from '@ngx-translate/core';
import { calcularDisponibilidad } from '../../_helpers';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-inventarios',
  templateUrl: './inventarios.component.html',
  styleUrls: ['./inventarios.component.scss']
})
export class InventariosComponent implements OnInit {
  sin_shopify   : boolean;
  user          : any;
  seller_id     : any;
  deshabilitado = false;
  current_user  : any;

  constructor(
    private inventarioService: InventarioService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.asignarDatos();
    this.authenticationService.currentUser.subscribe(x => this.user = x);
    if(this.user){
      if(this.user["seller_id"] == 3){
        this.deshabilitado = true;
      }
    }
    this.inventarioService.consultarIntegracion()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("la data es");
          // console.log(data);
          if (data.status == 200){
            if(data.body["items"][0]["status"] == "Conectado"){
              this.sin_shopify = false;
            }else{
              this.sin_shopify = true;
            }
          }

        },
        error => {
     });
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  tabClick(tab) {
    // console.log("tab es")
    // console.log(tab);
    if(tab["index"] == 2){
      const mensaje_bienvenida = this.dialog.open(DialogFormulario ,{width:'550px', height: 'auto',disableClose: true, data: {}});
    }
  }
}


@Component({
  selector: 'inventarios-tab-1',
  templateUrl: './inventarios-tab-1.html',
  styleUrls: ['./inventarios.component.scss']

})
export class InventariosTab1 implements AfterViewInit {

  displayedColumns: string[] = [
                                  'canal',
                                  'shopify_name',
                                  'shopify_created_at',
                                  'stock_disponible',
                                  'presale_stock',
                                  'safety_stock',
                                  'backorders_stock',
                                  'disponible_venta',
                                  'scrap_stock',
                                  'cliente',
                                  // 'payment_status',
                                ];
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength      = 0;
  isLoadingResults   = true;
  isRateLimitReached = false;
  guiaForm           : FormGroup;
  keywords           = "";
  formBO             : FormControl;
  spinner            = false;
  hay_datos          = true;
  titulo_diff        = false;
  datos_iniciales    = true;
  current_user       : any
  delayTimer         : any;


  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private inventarioService: InventarioService,
      private snackBar: MatSnackBar,
      private router: Router,
      private authenticationService: AuthenticationService
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;



  ngAfterViewInit() {


    this.entradaDatabase = new EntradaDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // console.log("las keywords iniciales son " + this.keywords)
    this.hacerTabla(this.keywords);
    this.formBO = new FormControl('', [ ]);


  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywords);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)
          if(data.items.length == 0) {
            this.hay_datos = false
            this.datos_iniciales = false
          }else{
            this.hay_datos = true
            this.datos_iniciales = true
          }


          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }


  //  PARA DIALOGO GUIAS
  openDialog(entrada_token) {
    // console.log("Entro a dialog guia")

    //// console.log(correo)
    const dialogRef = this.dialog.open(DialogInventario ,{width:'450px', height: 'auto', data: {token: entrada_token}});

    dialogRef.afterClosed().subscribe(result => {
      // console.log("Cerramos el dialog");
      this.hacerTabla(this.keywords);
    });
  }

  applyFilter(event: Event) {
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      const filterValue = (event.target as HTMLInputElement).value;
      this.keywords = filterValue.trim().toLowerCase();
      // console.log("las keywords son ")
      // console.log(this.keywords)
      this.hacerTabla(this.keywords);
    }, 500);
  }

  onChange(value, item_id) {
    this.spinner = true;
    // console.log(value);
    // console.log(item_id);
    this.inventarioService.cambiarBackOrder(item_id, value)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data["message"][0]);
        this.spinner = false;
        this.snackBar.open(data["message"][0], "OK", {
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
    });
  }

  openDialogEntrada(item_id, seller_sku, titulo){
    // Hacer request para consular el bundle y que responda como
    // render {items => los componentes del bundle que venga (sku, producto, cantidad) }
    // DESCOMENTAR CUANDO ESTE EL REUQEST LISTO
    this.inventarioService.consultarBundle(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar Bundle es");
        // console.log(data);
        if(data.status == 200){
          const dialogRef3 = this.dialog.open(DialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
        }
      },
      error => {
    });

    // Quitar cuando ya se tenga el request
    // let data = {items: []} // Comentar cuando ya se tenga el request
    // const dialogRef3 = this.dialog.open(DialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
  }

  showEtiqueta(item_id, seller_sku){
    if(seller_sku != ""){
      this.spinner = true
      this.inventarioService.getEtiqueta(item_id, seller_sku)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data)
          if(data.status == 200){
            if(data.body["se_puede"] == true){
              window.open(data.body["status"], "_blank");
              this.spinner = false
            }else{
              this.snackBar.open("El producto debe tener un SKU menor o igual a 15 caracteres.", "OK", {
                duration: 5000,
              });
              this.spinner = false
            }
            //const dialogRef3 = this.dialog.open(DialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
          }else{
            this.snackBar.open("Ocurrio un error al generar la etiqueta", "OK", {
              duration: 5000,
            });
            this.spinner = false
          }
        },
        error => {
      });
    }else{
      this.snackBar.open("El producto debe tener un SKU menor o igual a 15 caracteres.", "OK", {
        duration: 5000,
      });
    }

  }

  surtirBO(item_id){
    this.spinner = true
    this.inventarioService.consultarBO(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar bo es");
        // console.log(data);
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.surtirBackOrder(item_id);
          }else{
            this.spinner = false;
            this.snackBar.open("No existe ninguna BackOrder que surtir por el momento.", "OK", {
              duration: 3500,
            });
          }
        }

      },
      error => {
    });
  }

  surtirBackOrder(item_id){
    this.inventarioService.surtirBO(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("surtirBO es");
        // console.log(data);
        if(data["result"] == 200){
          this.consultarStatusBO(item_id);
        }
      },
      error => {
    });
  }

  consultarStatusBO(item_id){
    this.inventarioService.consultarStatusBO(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("surtirBO es");
        // console.log(data);
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.spinner = false;
            this.snackBar.open(data.body["result"][1], "OK", {
              duration: 3500,
            });
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/inventarios']);
            });
          }else{
            setTimeout(() =>
            {
              this.consultarStatusBO(item_id);
            },3000);
          }
        }
      },
      error => {
    });
  }
  ngOnInit() {
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  disponible_venta(item){
    const available_stock = calcularDisponibilidad(item);
    return available_stock;
  }
}

export interface EntradabApi {
  items: EntradaIssue[];
  total_count: number;
}

export interface EntradaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class EntradaDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
     const href = `${environment.apiUrl}/items.json`;
    // const href = 'http://localhost:3000/rmsfe/query_entradas.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&nombre_producto=${filtro}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}

export class MovinDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtroSKU: string, filtroProducto: string): Observable<EntradabApi> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
     const href = `${environment.apiUrl}/historial_inventarios.json`;
    // const href = 'http://localhost:3000/rmsfe/query_entradas.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&sku=${filtroSKU}&nombre_producto=${filtroProducto}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}



@Component({
  selector: 'inventarios-tab-2',
  templateUrl: './inventarios-tab-2.html',
  styleUrls: ['./inventarios.component.scss']

})
export class InventariosTab2 implements AfterViewInit {

  displayedColumns: string[] = [
                                  'created_at',
                                  'canal',
                                  'movimiento_name',
                                  'seller_sku',
                                  'nombre_producto',
                                  'tipo_movimiento',
                                  'stock_antes',
                                  'cantidad_variacion',
                                  'stock_despues',
                                  'sku'
                                ];

  entradaDatabase: MovinDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  keywordsSKU = "";
  keywordsProducto = "";
  hay_datos = true;
  titulo_diff = false;
  datos_iniciales = true;
  delayTimerSKU : any;
  delayTimerProducto : any;

  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;



  ngAfterViewInit() {

    this.entradaDatabase = new MovinDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // console.log("las keywords iniciales son " + this.keywords)
    this.hacerTabla();
  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  hacerTabla(){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywordsSKU, this.keywordsProducto);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)
          if(data.items.length == 0) {
            this.hay_datos = false
            this.datos_iniciales = false
          }else{
            this.hay_datos = true
            this.datos_iniciales = true
          }


          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }


  //  PARA DIALOGO GUIAS
  openDialog(entrada_token) {
    // console.log("Entro a dialog guia")

    //// console.log(correo)
    const dialogRef = this.dialog.open(DialogInventario ,{width:'450px', height: 'auto', data: {token: entrada_token}});

    dialogRef.afterClosed().subscribe(result => {
      // console.log("Cerramos el dialog");
      this.hacerTabla();
    });
  }

  applyFilterSKU(event: Event) {
    clearTimeout(this.delayTimerSKU);
    this.delayTimerSKU = setTimeout(() => {
      const filterValue = (event.target as HTMLInputElement).value;
      this.keywordsSKU = filterValue.trim().toLowerCase();
      // console.log("las keywords son ")
      // console.log(this.keywords)
      this.hacerTabla();
    }, 500);
  }

  applyFilterProducto(event: Event) {
    clearTimeout(this.delayTimerProducto);
    this.delayTimerProducto = setTimeout(() => {
      const filterValue = (event.target as HTMLInputElement).value;
      this.keywordsProducto = filterValue.trim().toLowerCase();
      // console.log("las keywords son ")
      // console.log(this.keywords)
      this.hacerTabla();
    }, 500);
  }

}


@Component({
  selector: 'inventarios-tab-3',
  templateUrl: './inventarios-tab-3.html',
  styleUrls: ['./inventarios.component.scss']

})
export class InventariosTab3 implements OnInit {
  formTitulo: FormControl;
  formSku: FormControl;
  formEan: FormControl;
  breakpoint: number;
  columna1: number;
  columna2: number;
  columna3: number;
  columna4: number;
  spinner = false;
  constructor(private inventarioService: InventarioService,
    private router: Router,
    private snackBar: MatSnackBar,
    ) { }

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
    this.columna4 = (window.innerWidth <= 599) ? 1 : 1;

    this.formTitulo = new FormControl('', [
      Validators.required,
    ]);

    this.formSku = new FormControl('', [
      Validators.required,
    ]);

    this.formEan = new FormControl('', []);

  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
    this.columna4 = (window.innerWidth <= 599) ? 1 : 1;
  }

  validarDatos(){
    if(this.formTitulo.invalid && this.formSku.invalid){
      return;
    }else{
      this.spinner = true;
      this.inventarioService.crearItem(this.formTitulo.value, this.formSku.value, this.formEan.value)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("la data es");
          // console.log(data);
          // console.log("status es "+data["status"])
          if (data["status"] == 200){
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/inventarios']);
            });
          }
          this.snackBar.open(data["message"], "OK", {
            duration: 7500,
          });
         this.spinner = false;
        },
        error => {
          this.snackBar.open("Hubo un error al crear el producto", "OK", {
            duration: 7500,
          });
     });
    }
  }

}


@Component({
  selector: 'dialog-inventario',
  templateUrl: './dialog-inventario.html',
})
export class DialogInventario {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogInventario>,
    private entradaService: EntradaService,
    private translate : TranslateService ,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.token){
      this.entrada_token = this.data.token;
      // console.log("El token es "+this.entrada_token);
    }
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl('', [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl('', [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl('', [Validators.required]);
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }

  guardarGuia(){
    if (this.guiaFormGuia.invalid || this.formPaqueteria.invalid || (this.otra && this.paqueteriaFormGuia.invalid)){
      // console.log("campos invalidos");
      return;
    }
    this.loading = true;
    this.spinner = true;

    this.mensaje_success = true;
    this.loading = false;
    this.spinner = false;

    // console.log(this.guiaFormGuia.value)
    // console.log(this.formPaqueteria.value)
    if(this.otra){
      this.paqueteria = this.paqueteriaFormGuia.value;
    }else{
      this.paqueteria = this.formPaqueteria.value;
    }
    this.entradaService.actualizarEntrada(this.entrada_token, this.guiaFormGuia.value, this.paqueteria)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data.body["message"]);
        if(data.status == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
        }else{
          this.error = data.body["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
   });
  }

}


export interface EntradabApi2 {
  items: ItemsIssue[];
  total_count: number;
}


export class EntradaDatabaseItems {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(filtro: string): Observable<EntradabApi2> {
    const href = `${environment.apiUrl}/rmsfe/listar_items.json`;
    const requestUrl = `${href}?nombre_producto=${filtro}`;
    return this._httpClient.get<EntradabApi2>(requestUrl);
  }
}

export interface ItemsIssue {
  id: number;
  seller_sku: string;
  title: string;
  available_quantity: number;
}

export interface ProductosEntrada {
  sku: string;
  producto: string;
  cantidad: number;
}

@Component({
  selector: 'dialog-bundle',
  templateUrl: './dialog-bundle.html',
  styleUrls: ['./inventarios.component.scss']

})

export class DialogBundle implements OnInit {

  params: any;
  item_bundle: any;

  constructor(public dialog: MatDialog,
  private snackBar: MatSnackBar,
  private _httpClient: HttpClient,
  public dialogRef: MatDialogRef<DialogBundle>,
   private inventarioService: InventarioService,
  @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(this.data.item_id){
      // console.log("la data es")
      // console.log(this.data)
      this.item_bundle = this.data.item_id;
      // console.log("Params son")
      this.params = this.data.params;
      // console.log(this.data.params)
      // console.log(this.data.params.body["items"])
      // console.log(this.params)
      this.datos_tabla = this.params.body["items"];
      this.puede_ser_bundle = this.params.body["puede_ser_bundle"];
      // console.log("data de tabla es")
      // console.log(this.datos_tabla)
      // this.entradaFinal = this.datos_tabla;
      // this.datos_tabla = [{}]
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });
    }
  }
  breakpoint: number;
  columna1: number;
  columna2: number;
  columna3: number;
  not_found = false;
  entrada_final: [];
  ya_existe: number;
  filterName:string;
  filterCantidad: string;
  entradaDatabase: EntradaDatabaseItems | null;
  isLoadingResults = true;
  isRateLimitReached = false;
  resultsLength = 0;
  keywords = "";
  // data: object;
  dataItems: ItemsIssue[] = [];
  status_form = "reset"
  spinner = false;

  // MyArrayType = Array<{sku: string, producto: string, cantidad: number}>;
  entradaFinal:ProductosEntrada[] = [];
  displayedColumns = ['sku', 'producto', 'cantidad', 'action'];
  datos_tabla: ProductosEntrada[] = []
  puede_ser_bundle: true;



  itemForm = new FormControl('', [
    Validators.required,
  ]);

  cantidadForm = new FormControl('', [
    Validators.required,
    Validators.min(1),
  ]);


  options:[
  ];
  filteredOptions: Observable<ItemsIssue[]>;
  ngAfterViewInit() {


    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    // this.hacerAutcomplete();
  }

  ngOnInit() {
    // console.log("Entro a ongit")
    this.breakpoint = (window.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    this.hacerAutcomplete(this.keywords);
    // console.log("los items son")
    // console.log(this.dataItems)

   // this.entradaFinal = this.datos_tabla;

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    this.hacerAutcomplete(this.keywords);
  }

  filterStates(s: any) {
    let stateName = s.seller_sku || s; // s can be a State or a string
    return this.dataItems.filter(state =>
      state.seller_sku.toLowerCase().indexOf(stateName.toLowerCase()) === 0);
  }

  hacerAutcomplete(filtros){
    merge()
    .pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.entradaDatabase!.getRepoIssues(filtros);
      }),
      map(data => {
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        this.resultsLength = data.total_count;
        // console.log("vamos con los items")
        // console.log(data)
        return data.items;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        // Catch if the GitHub API has reached its rate limit. Return empty data.
        this.isRateLimitReached = true;
        return observableOf([]);
      })
    ).subscribe(data => this.dataItems = data);
  }

  displayFn(subject){
    let texto = "";
    if(subject){
      if(subject.seller_sku){
        texto = subject.seller_sku + " | Cantidad Disp." + subject.available_quantity
        return texto;
      }else if(subject.title){
        texto = subject.title + " | Cantidad Disp." + subject.available_quantity
        return texto;
      }
    }else{
      return undefined;
    }

  }

  actualizarBundle(){
    // tomar this.entrada_final que seran los Component y this.item_bundle el bundle_name_item_id
    //Hacer request para hacer el bundle

    // Descomentar cuando ya se tenga el request

    this.inventarioService.cambiarBundle(this.entradaFinal, this.item_bundle)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data["message"]);
        this.spinner = false;
        this.snackBar.open(data["message"], "OK", {
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
    });


    // this.dialogRef.close();
  }

  validarDatos(){
    this.status_form = "submitted"
    if(this.itemForm.invalid || this.cantidadForm.invalid){
      return;
    }
    let elItem = this.itemForm.value;
    if(!elItem){
      return;
    }
    // console.log(this.itemForm.value);
    // console.log(elItem)
    let producto = elItem.title;
    let item_id = elItem.id;
    let el_seller_sku = elItem.seller_sku;
    let cantidad_maxima = elItem.available_quantity
    // console.log("el item_id es "+item_id)
    // console.log("typeof "+  typeof item_id)
    if(!item_id){
      this.snackBar.open("Debes agrear un producto valido", "OK", {
        duration: 3500,
      });
      return;
    }

    if(elItem.bundle > 0){
      this.snackBar.open(`EL SKU: ${elItem.seller_sku} es un bundle, por lo tanto, no puede agregarse como componente de otro bundle`, "OK", {
        duration: 3500,
      });
      return;
    }
    // if(this.cantidadForm.value > cantidad_maxima){
    //   if(cantidad_maxima == 0 && elItem.acepta_bo){

    //   }else{
    //     this.filterCantidad = "";
    //     this.snackBar.open("No puedes agregar más de la cantidad disponible", "OK", {
    //       duration: 3500,
    //     });
    //     return;
    //   }
    // }
    //this.status_form = "reset"
    this.filterName = null;
    this.filterCantidad = null;
    this.addItem(this.entradaFinal, el_seller_sku, this.cantidadForm.value, producto, item_id);
    // this.entradaFinal.push({sku: this.itemForm.value, producto: producto, cantidad: this.cantidadForm.value});
    // // console.log(this.entradaFinal);
    this.datos_tabla = this.entradaFinal;
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value;
    });
    // console.log("La entrada_final es")
    // console.log(this.entradaFinal)
  }

  addItem(arr, seller_sku, quantity, titulo, item_id) {
    // console.log("arr es" +arr);
    let { length } = arr;
    let id = length + 1;
    let found = arr.some(el => el.sku === seller_sku);
    if (!found){
      arr.push({sku: seller_sku, producto: titulo, cantidad: quantity, item_id: item_id});
    }else{
      let index = arr.findIndex(x => x.sku === seller_sku);
      // console.log("el repetido es el " + index);
      arr[index].cantidad = arr[index].cantidad + quantity;
    }
    return arr;
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
  }

  deleteRowData(row_obj){
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value.sku != row_obj.sku;
    });
    this.entradaFinal = this.datos_tabla;
    // console.log(this.entradaFinal)
  }


  /** Gets the total cost of all datos_tabla. */
  getTotalCost() {
    return this.datos_tabla.map(t => t.cantidad).reduce((acc, value) => acc + value, 0);
  }

}

@Component({
  selector: 'dialog-formulario',
  templateUrl: './dialog-formulario.html',
  styleUrls: ['./inventarios.component.scss'],
})
export class DialogFormulario {
  params : any;
  usuario: string;
  datos_tabla: ProductosEntrada[] = []
  displayedColumns = ['sku', 'producto', 'cantidad'];
  formAsegurar: FormControl;
  user: any;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogFormulario>,
    private authenticationService: AuthenticationService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){

  }

  ngOnInit(){

  }

  irIntegracion(){
    this.router.navigate(['/integrations']);
    this.dialogRef.close();
  }

}





@Component({
  selector: 'inventarios-tab-4',
  templateUrl: './inventarios-tab-4.html',
  styleUrls: ['./inventarios.component.scss']

})
export class InventariosTab4 implements OnInit {

  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  progress = false;
  descargar = false;
  url_descargar = "";
  formFile: FormControl;
  file_name: string;
  fileToUpload: File = null;
  exito = false;
  enviado = true;
  spinner = false;

  constructor(private _formBuilder: FormBuilder,
    private entradaService: EntradaService,
    private fulfillmentService: FulfillmentService,
    private inventarioService: InventarioService,
    private snackBar: MatSnackBar,
    private router: Router,
    public dialog: MatDialog
    ) {}

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.formFile = new FormControl('', Validators.required);
    this.inventarioService.consultarPlantilla()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar status es");
        // console.log(data);
        // console.log(data.body)
        // console.log(data.status)
        // console.log(data.body["result"])
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.url_descargar = data.body["url_descargar"];
            this.progress = false;
            this.descargar = true;
          }else{
            setTimeout(() =>
            {
              this.consultarStatusPlantilla();
            },3000);
          }
        }
      },
      error => {
    });
  }

  consultarStatusPlantilla(){

  }

  handleFileInput(files: FileList) {
    this.spinner = true;
    this.fileToUpload = files.item(0);
    // console.log("el file")
    // console.log(this.fileToUpload)
    this.fulfillmentService.getUploadURlXlsx(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        if(data.status == 200){
          this.subirAWS(data.body["data"], this.fileToUpload);
        }else{
          // console.log("entro en else")
        }
      },
      error => {
    });
  }

  subirAWS(response, fileToUpload){
    // console.log("entramos en subirAWS")
    // console.log(response)
    this.file_name = response.file_name
    // console.log("El file final es "+ this.file_name)
    // console.log(response.url)
    this.fulfillmentService.subirArchivoXLS(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("respondio aws")
        // console.log(data)
        this.enviado = false;
        this.spinner = false;
      },
      error => {
    });
  }

  enviarEntradaMasiva(){
    this.enviado = true;
    if(this.formFile.invalid){
      this.snackBar.open("Debes anexar el formato primero.", "OK", {
        duration: 3500,
      });
    }else{
      this.spinner = true;
      this.inventarioService.mandarEntrada(this.file_name)
      .pipe(first())
      .subscribe(
        data => {
          // console.log(data);
          if(data.status == 200){
            this.consultarStatusMasivo();
          }
        },
        error => {
      });
    }
  }

  consultarStatusMasivo(){
    this.inventarioService.consultarMasivo()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar status es");
        // console.log(data);
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.snackBar.open("Productos Registrados Correctamente", "OK", {
              duration: 3500,
            });
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/inventarios']);
            });
          }else{
            setTimeout(() =>
            {
              this.consultarStatusMasivo();
            },3000);
          }
        }
      },
      error => {
    });
  }

}
